import React from 'react';
import { Modal } from 'antd';
import '../../../index.scss';

const NewBonusAmount = ({ showModal, hideModal, setAmount, setDescription, amount, description, className, handleCreateNew }) => {
  return (
    <Modal
      className={className}
      centered
      visible={showModal}
      onCancel={() => hideModal(false)}
      width={400}
      footer={null}
      title="Create Bonus Amount"
    >
      <div className='col-md-12 mt-4'>
        <label className='form-label'>Amount to receive</label>
        <input
          type='text'
          className='form-control'
          value={amount}
          required
          onChange={(e) => setAmount(e.target.value)}
          placeholder="e.g. 1000"
        />
      </div>
      <div className='col-md-12 mt-3'>
        <label className='form-label'>Description</label>
        <input
          type='text'
          className='form-control'
          value={description}
          required
          onChange={(e) => setDescription(e.target.value)}
          placeholder="e.g. Personal Referral Bonus"
        />
      </div>

      <div className='col-12 text-end mt-5'>
        <button className='btn btn-primary' type='button' onClick={handleCreateNew}>
          Save
        </button>
      </div>
    </Modal>
  );
};

export default NewBonusAmount;
